const MuiInputLabelOverrides = {
  MuiInputLabel: {
    defaultProps: {
      disableAnimation: true,
      shrink: true
    },
    styleOverrides: {
      root: _ref => {
        let {
          theme
        } = _ref;
        return {
          ...theme.typography.body02,
          color: theme.palette.blue80,
          marginBottom: theme.spacing(0.5),
          position: 'relative',
          transform: 'unset'
        };
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: _ref2 => {
        let {
          theme
        } = _ref2;
        return {
          ...theme.typography.body02,
          color: theme.palette.blue80
        };
      }
    }
  }
};

export { MuiInputLabelOverrides };
